/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SolrWorkReduced
 */
export interface SolrWorkReduced  {
    /**
     * 
     * @type {string}
     * @memberof SolrWorkReduced
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SolrWorkReduced
     */
    mainTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof SolrWorkReduced
     */
    subTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof SolrWorkReduced
     */
    subseriesTitle?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrWorkReduced
     */
    personName?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof SolrWorkReduced
     */
    recordCreationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SolrWorkReduced
     */
    recordChangeDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SolrWorkReduced
     */
    projectsChecked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SolrWorkReduced
     */
    editorialStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof SolrWorkReduced
     */
    issued?: number;
}

/**
 * Check if a given object implements the SolrWorkReduced interface.
 */
export function instanceOfSolrWorkReduced(value: object): value is SolrWorkReduced {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SolrWorkReducedFromJSON(json: any): SolrWorkReduced {
    return SolrWorkReducedFromJSONTyped(json, false);
}

export function SolrWorkReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrWorkReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'],
                  'mainTitle': json['mainTitle'] == null ? undefined : json['mainTitle'],
                  'subTitle': json['subTitle'] == null ? undefined : json['subTitle'],
                  'subseriesTitle': json['subseriesTitle'] == null ? undefined : json['subseriesTitle'],
              'personName': json['personName'] == null ? undefined : json['personName'],
                'recordCreationDate': json['recordCreationDate'] == null ? undefined : (new Date(json['recordCreationDate'])),
                'recordChangeDate': json['recordChangeDate'] == null ? undefined : (new Date(json['recordChangeDate'])),
                  'projectsChecked': json['projectsChecked'] == null ? undefined : json['projectsChecked'],
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
                  'issued': json['issued'] == null ? undefined : json['issued'],
    };
}

export function SolrWorkReducedToJSON(json: any): SolrWorkReduced {
    return SolrWorkReducedToJSONTyped(json, false);
}

export function SolrWorkReducedToJSONTyped(value?: SolrWorkReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'mainTitle': value['mainTitle'],
        'subTitle': value['subTitle'],
        'subseriesTitle': value['subseriesTitle'],
        'personName': value['personName'] == null? value['personName']: value['personName'],
        'recordCreationDate': value['recordCreationDate']?.toISOString(),
        'recordChangeDate': value['recordChangeDate']?.toISOString(),
        'projectsChecked': value['projectsChecked'],
        'editorialStatus': value['editorialStatus'],
        'issued': value['issued'],
    };
}


